const token = (state = null, action = {})=>{
    if (action.type === 'SET_TOKEN') return action.token;
    return state
};
const user = (state = {}, action = {})=>{
    if (action.type === 'SET_USER') return action.user;
    return state;
};
const boot = (state = false, action = {})=>{
    if (action.type === 'SET_FIRST_BOOT') return action.boot;
    return state;
};
const routerData = (state = {}, action = {})=>{
    if (action.type === 'SET_ROUTER_DATA') return action.routerData;
    return state;
};
const location = (state = { lat: 35.696747, lng: 51.378444 ,state_id : 8 , city_id :334,address:''}, action = {})=>{
    if (action.type === 'SET_LOCATION') return action.location;
    return state;
};
const language = (state = { lang :"fa"}, action = {})=>{
    if (action.type === 'SET_LANGUAGE') return action.language;
    return state;
};
const theme = (state = 'light', action = {})=>{
    if (action.type === 'SET_THEME') return action.theme;
    return state;
};
const accidentInfo = (state = {}, action = {})=>{
    if (action.type === 'SET_ACCIDENT_INFO') return action.accidentInfo;
    return state;
};
const insuranceCode = (state = null , action= {})=>{
    if (action.type === 'SET_INSURANCE_CODE') return action.insuranceCode;
    return state;
}
const userAction = (state = null , action= {})=>{
    if (action.type === 'SET_USER_ACTION') return action.userAction;
    return state;
}
const reducers = { user, token, boot, routerData, location , language, theme, accidentInfo, insuranceCode,userAction}
export default reducers;
